import { exists } from '@/api'

export interface BibliographySetDetailAuthority {
  tag: string
  authorityNo: string
  authorityTag: string
  data: string
}

export function BibliographySetDetailAuthorityFromJSON(
  json: any
): BibliographySetDetailAuthority {
  return {
    tag: exists(json, 'tag') ? json.tag : '',
    authorityNo: exists(json, 'authority_no') ? json.authority_no : '',
    authorityTag: exists(json, 'authority_tag') ? json.authority_tag : '',
    data: exists(json, 'data') ? json.data : ''
  }
}
